import axios from "axios";
import { Payout_Service } from "../Url";

export const partnerinvoiceUploadActions = {
    PARTNER_INVOICE_UPLOAD_SUCCESS: "PARTNER_INVOICE_UPLOAD_SUCCESS",
    PARTNER_INVOICE_UPLOAD_FAILURE: "PARTNER_INVOICE_UPLOAD_FAILURE"
};

export function getInvoiceUploadAction(props) {
    const { accessToken, formData } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                url: `${Payout_Service}/reports/submitPartnerDocs`,
                // url: `http://localhost:8301/partner-payout-service/reports/submitPartnerDocs`,
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "multipart/form-data",
                },
                data: formData, 
            });

            console.log(response);
            return response.data;
        } catch (error) {
           
            return error;
        }
    };
}

export function submitInvoicesForProccesing(props){

     const { accessToken, partner_id, report_id } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                url: `${Payout_Service}/reports/savePartnerDocsMetaData?partnerid=${partner_id}&reportid=${report_id}`,
                //  url: `http://localhost:8301/partner-payout-service/reports/savePartnerDocsMetaData?partnerid=${partner_id}&reportid=${report_id}`,
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },

            });

            console.log(response);
            return response.data;
        } catch (error) {
            
            return error;
        }
    };

}

 export function getInvoiceData(props){
      const { accessToken, partnerId, reportId } = props;
        return async (dispatch) => {
            try {
                const response = await axios({
                    method: "POST",
                    url: `${Payout_Service}/reports/get/invoiceAndPayoutDetails?partnerId=${partnerId}&reportId=${reportId}`,
                    //  url: `http://localhost:8301/partner-payout-service/reports/get/invoiceAndPayoutDetails?partnerId=${partnerId}&reportId=${reportId}`,
                    headers: {
                        Authorization: "Bearer " + accessToken,
                        "Access-Control-Allow-Origin": "*",
                    },
                   
                });

                console.log(response);
                return response.data;
            } catch (error) {
                // Optionally dispatch an error action here
                return error;
            }
        };
 }

 export function getInvoiceDownload(props){
     const { accessToken, filePath} = props;
        return async (dispatch) => {
            try {
                const response = await axios({
                      method: "GET",
                     url: `${Payout_Service}/reports/download/partnerDoc?path=${filePath}`,
                    // url: `http://localhost:8301/partner-payout-service/reports/download/partnerDoc?path=${filePath}`,
                    headers: {
                        Authorization: "Bearer " + accessToken,
                        "Access-Control-Allow-Origin": "*",
                    },
                   
                });

                console.log(response);
                return response;
            } catch (error) {
                // Optionally dispatch an error action here
                return error;
            }
        };
 }

 export function invoiceUploadDeleteAction (props) {
     const { accessToken, invoiceId } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                url: `${Payout_Service}/reports/delete/invoiceAndPayoutDetails?id=${invoiceId}`,
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
            });
            console.log(response);
           return response;
        } catch (error) {
            console.error("Error deleting invoice:", error);
            return error;
        }
    };
}
